import {IItem} from './types';

export const itemPredicate = (query: string, item: IItem) => {
  return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
}
